import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const FAQs = () => {
  return (
    <PlaceholderPage title="Frequently Asked Questions">
      Find answers to common questions about admissions, applications, financial aid, and student life at FIC College.
    </PlaceholderPage>
  );
};

export default FAQs;
